// extracted by mini-css-extract-plugin
module.exports = {"unprintable":"print_unprintable__KCAm2"};